import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CreatePlaylistModal from './CreatePlaylistModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreatePlaylistModalTrigger = ({
  item,
  renderTrigger
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderTrigger ? renderTrigger({
      openModal,
      isOpen
    }) : /*#__PURE__*/_jsx(Button, {
      onClick: openModal,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.savedItems.createPlaylist"
      })
    }), isOpen && /*#__PURE__*/_jsx(CreatePlaylistModal, {
      itemToAdd: item,
      onRequestClose: closeModal
    })]
  });
};
export default CreatePlaylistModalTrigger;